import React from 'react';
import { connect } from 'react-redux';
import { editUsuario, fetchUsuario } from '../../actions/usuariosActions';
import { fetchSeller, editSeller } from '../../actions/sellersActions';
import { editando, setObject } from '../../actions/generalActios';
import { fetchTiposPublicacion } from '../../actions/publicacionesActions';
import {
  putSeller,
  deleteSellerApi,
  postTiposPublicacionAsociarSeller
} from '../../api/axios';
import DatosContactos from './DatosContactos';
import DatosBasicos from './DatosBasicos';
import Publicacion from './Publicacion';
import Contraseña from './Contraseña';
import Moderador from './Moderador';
import MailUsuario from './MailUsuario';
import Liquidacion from './Liquidacion';
import Tab from '../General/Tab';
import ModalItem from '../General/Modal';
import GoBackArrow from '../General/GoBackArrow';
import MiniSpinner from '../General/MiniSpinner';
import BigSpinner from '../General/BigSpinner';
import LogisticaPropia from "./LogisticaPropia";
import { isEmail } from '../../utilities/formatString';
import { toast } from 'react-toastify';


class SellerEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: this.props.location.state ?? 0,
      tabs: [
        { name: "Datos Básicos ", icon: "ti-home", content: <DatosBasicos /> },
        { name: "Datos de contactos", icon: "ti-home", content: <DatosContactos /> },
        { name: "Publicación ", icon: "mdi mdi-tag", content: <Publicacion history={this.props.history} /> },
        {
          name: "Moderador", icon: "ti-home",
          content: <Moderador
            tipoUsuario={this.props.tipoUsuario}
            changeTab={this.onChangeActiveTab}
            history={this.props.history} />
        },
        { name: "Usuario", icon: "mdi mdi-email-outline", content: <MailUsuario /> },
        { name: "Liquidacion", icon: "mdi mdi-google-analytics", content: <Liquidacion tipoUsuario={this.props.tipoUsuario} /> }
      ],
      showSpinner: false
    };
    const { isCategory, isAdminMod } = this.props.userType;
    this.isSeller = !isCategory && !isAdminMod;
  }

  componentDidMount() {
    if (this.props.history.location.pathname != `/Sellers/Editar/Select/${this.props.match.params.id}`) {
      this.props.setObject({});
    }

    this.props.editUsuario({});
    this.props.editando(true);
    this.props.fetchSeller(this.props.match.params.id);
    this.props.fetchUsuario({ idSeller: parseInt(this.props.match.params.id) });
    this.props.fetchTiposPublicacion(parseInt(this.props.match.params.id));

    if (this.isSeller) {
      let tabsSeller = [
        { name: "Datos Básicos ", icon: "ti-home", content: <DatosBasicos estado={this.props.seller.estado} /> },
        { name: "Datos de contactos", icon: "ti-home", content: <DatosContactos /> },
        { name: "Publicación", icon: "ti-home", content: <Publicacion history={this.props.history} /> },
        { name: "Administrar Cuenta ", icon: "ti-home", content: <Contraseña /> }
      ]

      this.setState({ tabs: tabsSeller });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.seller !== prevProps.seller) {
      if (this.props.seller.envioPropio === true) {
        const tabLogisticaPropia = {
          name: "Logística Propia",
          icon: "ti-home",
          content: <LogisticaPropia idSeller={this.props.match.params.id} userType={this.props.userType} />
        };
        const tabExists = this.state.tabs.some(tab => tab.name === "Logística Propia");
        if (!tabExists) {
          this.setState(prev => ({ tabs: [...prev.tabs, tabLogisticaPropia] }));
        }
      }
    }
  }

  onChangeActiveTab = (index) => { this.setState({ activeTab: index }) };

  onSubmit = async (event) => {
    event.preventDefault();

    if (this.props.userType.isAdminMod || this.props.userType.isCategory) {
      this.updateSeller();
    } else {
      if (!this.props.usuarioError && JSON.stringify(this.props.usuario) != "{}") {
        setTimeout(() => {
          if (!this.props.usuario.error) {
            this.props.editUsuario({});
            this.submitFromSeller();
          };
        }, 500)
      }
      else {
        if (JSON.stringify(this.props.usuario) != "{}") {
          toast.error("Las contraseñas no coinciden");
        }
        if (!this.props.usuarioError) {
          this.submitFromSeller();
        }
      }
    }
  }

  updateSeller = () => {
    this.asignarTipoPublicacion();
    let sellers = putSeller(this.props.seller);
    sellers.then(res => {
      toast.success("Seller modificado");
      this.goBack();
    }).catch(err => {
      (err.response.data.errores)
        ? err.response.data.errores.forEach(error => toast.error(error))
        : toast.error("No pudo modificarse");
    }).finally(() => {
      this.setState({ showSpinner: false });
    });
  };

  submitFromSeller = () => {
    let seller = this.props.seller;

    if (!isEmail(seller.email)) {
      toast.warn("e-Mail incorrecto");
      return;
    }

    this.setState({ showSpinner: true });
    this.asignarTipoPublicacion();
    this.updateSeller();
  }

  asignarTipoPublicacion = () => {
    let listaIdTiposPublicaciones = [];
    for (let index = 0; index < this.props.settedTiposPublicacion.length; index++) {
      let element = this.props.settedTiposPublicacion[index].codigo;
      listaIdTiposPublicaciones.push(element);
    }

    let request = {
      "idSeller": this.props.seller.codigo,
      "listaIdsTipoPublicacion": listaIdTiposPublicaciones
    };

    let continuarAsignacion = true;
    for (let index = 0; index < listaIdTiposPublicaciones.length; index++) {
      if (listaIdTiposPublicaciones[index] == undefined) {
        continuarAsignacion = false;
        break;
      }
    }

    if (continuarAsignacion) {
      const req = postTiposPublicacionAsociarSeller(request);
      req.then(res => {
        toast.success("Tipo de publicación asociado");
      }).catch(err => {
        toast.warn("Tipo de publicación no asociado");
      });
    }
  }

  onDelete = () => {
    this.setState({ showSpinner: true });

    const req = deleteSellerApi(this.props.seller.codigo);
    req.then(res => {
      toast.success("Vendedor borrado");
      this.goBack();
    }).catch(err => {
      toast.error("No se pudo eliminar");
    }).finally(() => {
      this.setState({ showSpinner: false });
    });
  }

  goBack = () => {
    if (this.props.userType.isCategory || this.props.userType.isAdminMod) {
      this.props.history.push("/Sellers");
    } else {
      this.props.history.push("/");
    }
  }


  render() {
    const { isCategory, isAdminMod } = this.props.userType;

    let codigo = this.props.seller != undefined ? this.props.seller.codigo : "";
    let hideLoader = false;
    if (codigo != undefined) {
      hideLoader = true;
    }

    return (
      <div className="container">
        <div className="row align-items-center">

          {!hideLoader ? <BigSpinner /> :
            <div className="card">
              <div className="col-12 mt-4">

                <GoBackArrow />

                <h4 className="card-title d-block d-sm-inline">
                  {this.props.userName} - {this.props.seller.razonSocial}
                </h4>
                <h4 className="col-auto card-title">Editar Seller - {codigo}</h4>
                <h5 className="col-auto card-subtitle">{this.props.seller.razonSocial}</h5>
              </div>

              <div className="card-body p-b-0">

                <ul className="nav nav-tabs customtab" role="tablist">
                  {
                    this.state.tabs.map((tab, index) => {
                      return <div key={index} onClick={() => this.onChangeActiveTab(index)}>
                        <Tab name={tab.name} icon={tab.icon} isActive={index === this.state.activeTab} />
                      </div>
                    })
                  }
                </ul>

                <form className="form-horizontal form-material p-10">
                  <div className="tab-content">

                    {this.state.tabs[this.state.activeTab].content}

                    <div className="row align-items-center justify-content-center mb-3 text-center">

                      <div className="col-12 col-sm-auto" hidden={!this.state.showSpinner}>
                        <MiniSpinner />
                      </div>

                      <button
                        onClick={this.onSubmit}
                        type="submit"
                        className="btn btn-sm background-rojo-megatone waves-light col-auto mx-2"
                        disabled={this.state.showSpinner}
                        hidden={this.state.tabs[this.state.activeTab].name === "Logística Propia"}
                      >
                        Guardar
                      </button>

                      {(isCategory || isAdminMod) &&
                        <ModalItem
                          btnStyle="btn btn-sm btn-grey col-auto mx-2"
                          btnText="Eliminar"
                          text="¿Desea eliminar Seller?"
                          disabled={this.state.showSpinner}
                          onDelete={this.onDelete}
                          show={this.state.showModal}
                        />
                      }

                      <button
                        onClick={this.goBack}
                        className="btn btn-sm btn-light waves-effect waves-light col-auto mx-2"
                      >
                        Cancelar
                      </button>

                    </div>
                  </div>
                </form>

              </div>
            </div>
          }

        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  usuario: state.usuarios.user,
  userName: state.general.userName,
  userType: state.general.userType,
  tipoUsuario: state.general.tipoUsuario,
  facturaciones: state.facturaciones,
  usuarioError: state.usuarios.error,
  settedTiposPublicacion: state.tiposPublicacion.setTiposPublicacion,
  seller: JSON.stringify(state.general.generalObject) != "{}"
    ? state.general.generalObject
    : state.sellers.seller
  ,
});

export default connect(mapStateToProps, {
  fetchSeller,
  editSeller,
  editUsuario,
  editando,
  setObject,
  fetchUsuario,
  fetchTiposPublicacion
})(SellerEdit);